<template>
  <div>
    <Card>
      <Row>
        <Button style="float: right;" v-show="isTypeOperate" @click="addParentType" type="primary" :style="{marginBottom: '10px'}" icon="md-add">添加分类</Button>
      </Row>
      <tables border search-place="bottom" :loading="tableLoading" v-model="tableData" :columns="columns"/>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ tableData.length }} 条记录，总共 {{ count }} 条记录
        </div>
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getTableData"></page>
        </div>
      </div>
      <Drawer
        :title="changeTitle"
        v-model="change"
        width="780"
        :mask-closable="true"
        @on-close="changeClose"
      >
        <Form ref="formItem" :model="formItem" :label-width="120" :rules="ruleValidate">
          <FormItem label="分类名称" prop="type_name">
            <Input v-model="formItem.type_name" placeholder="最大12个字符" :maxlength="12" />
          </FormItem>
          <FormItem label="是否需要审批">
             <i-switch v-model="formItem.is_approve">
              <span slot="open">是</span>
              <span slot="close">否</span>
             </i-switch>
          </FormItem>
          <FormItem label="审批邮箱" v-if="formItem.is_approve === true">
            <Input v-model="formItem.approve_email" placeholder="审批人邮箱, 如有多个, 请用英文分号; 分割" type="textarea"/>
          </FormItem>
          <FormItem label="抄送邮箱" v-if="formItem.is_approve === true">
            <Input v-model="formItem.cc_email" placeholder="抄送人邮箱, 如有多个, 请用英文分号; 分割" type="textarea"/>
          </FormItem>

          <FormItem label="用户阅读制度" v-if="formItem.is_approve === true">
            <Row>
              <Col span="2"> 名称</Col>
              <Col span="5">
                <Input v-model="formItem.file_name"/>
              </Col>

              <Col span="2" style="text-align: center">&nbsp;</Col>

              <Col span="2"> 文件链接</Col>
              <Col span="9">
                <Input v-model="formItem.file_link"/>
              </Col>
            </Row>
          </FormItem>

          <FormItem label="审批内容" v-if="formItem.is_approve === true">
            <!-- <Input v-model="formItem.type_illustrate" type="textarea"/> -->
            <editor ref="editor" :value="formItem.type_illustrate" @on-change="handleChange"/>
          </FormItem>

          <FormItem label="处理客服" prop="user">
            <transfer
              :data="all_user_list"
              :target-keys="formItem.user"
              :titles="['所有客服', '绑定的客服']"
              :list-style="listStyle"
              @on-change="changeUserSelect"
              filterable></transfer>
          </FormItem>
          <FormItem label="处理分组" prop="groups">
            <transfer
              :data="all_group_list"
              :target-keys="formItem.groups"
              :titles="['所有分组', '绑定的分组']"
              :list-style="listStyle"
              @on-change="changeGroupSelect"
              filterable></transfer>
          </FormItem>
          <FormItem label="分类描述" prop="description">
            <Input v-model="formItem.description" placeholder="分类指引描述" :maxlength="1024" type="textarea"/>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="changeSubmit" :loading="changeLoadingShow">提交</Button>
            <Button style="margin-left: 8px" @click="change=false; changeClose()">取消</Button>
          </FormItem>
        </Form>
      </Drawer>
      <Drawer
        :title="changeTitleSon"
        v-model="changeSon"
        width="720"
        :mask-closable="true"
        @on-close="changeCloseSon"
      >
        <Form ref="formItemSon" :model="formItemSon" :label-width="100" :rules="ruleValidateSon">
          <FormItem label="子类名称" prop="type_name">
            <Input v-model="formItemSon.type_name" placeholder="最大12个字符" :maxlength="12" />
          </FormItem>
          <FormItem>
            <Button type="primary" @click="changeSubmitSon" :loading="changeLoadingShowSon">提交</Button>
            <Button style="margin-left: 8px" @click="changeSon=false; changeCloseSon()">取消</Button>
          </FormItem>
        </Form>
      </Drawer>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import { GetALLUsers, getAllGroup } from '@/api/user'
import { GetWorkSheetType, ChangeWorkSheetType, DeleteWorkSheetType, ChangeWorkSheetTypeSon, getTypeNameList } from '@/api/logistics/type'
import expandRow from './type-expand.vue'
import Editor from '_c/editor'
export default {
  name: 'type-manage',
  components: {
    Tables,
    expandRow,
    Editor
  },
  data () {
    const validTypeName = (rule, value, callback) => {
      // 判断是否为空
      if (!value) {
        callback(new Error('分类名称不能为空 !'))
      }
      // 异步判断名字是否和数据库里面数据有重复
      if (!this.typeNameValid(value)) {
        callback(new Error('分类名称有重复，请重新输入'))
      } else {
        callback()
      }
    }
    return {
      isTypeOperate: false,
      typeNameList: [],
      change: false,
      changeSon: false,
      count: 0,
      size: 10,
      page: 1,
      tableLoading: false,
      tableLoadingSon: false,
      changeTitle: '添加角色',
      changeTitleSon: '添加子类',
      columns: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row,
                isTypeOperate: this.isTypeOperate
              },
              on: {
                'on-result-change': this.onResultChange,
                'on-delete-change': this.onSonTypeDelete
              }
            })
          }
        },
        // { type: 'selection', minWidth: 60, align: 'center' },
        { title: '分类名称', key: 'type_name', minWidth: 150, align: 'center' },
        { title: '处理客服', key: 'users_name', align: 'center', minWidth: 300 },
        { title: '处理分组', key: 'groups_name', align: 'center', minWidth: 100 },
        {
          title: '操作',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  display: this.isTypeOperate ? 'inline-block' : 'none',
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params.row)
                  }
                }
              }, '编辑'),
              h('Poptip', {
                props: {
                  confirm: true,
                  placement: 'bottom',
                  title: '你确定要隐藏吗?'
                },
                on: {
                  'on-ok': () => {
                    this.hide(params.row)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    display: this.isTypeOperate ? (params.row.is_display ? 'inline-block' : 'none') : 'none',
                    marginRight: '5px'
                  }
                }, '隐藏')
              ]),
              h('Poptip', {
                props: {
                  confirm: true,
                  placement: 'bottom',
                  title: '你确定要显示吗?'
                },
                on: {
                  'on-ok': () => {
                    this.display(params.row)
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    display: this.isTypeOperate ? (params.row.is_display ? 'none' : 'inline-block') : 'none',
                    marginRight: '5px'
                  }
                }, '显示')
              ]),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
                style: {
                  display: this.isTypeOperate ? 'inline-block' : 'none',
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.addSon(params.row)
                  }
                }
              }, '添加子类')
              // h('Poptip', {
              //   props: {
              //     confirm: true,
              //     placement: 'bottom',
              //     title: '你确定要删除吗?'
              //   },
              //   on: {
              //     'on-ok': () => {
              //       this.delete(params.row)
              //     }
              //   }
              // }, [
              //   h('Button', {
              //     props: {
              //       type: 'error',
              //       size: 'small'
              //     }
              //   }, '删除')
              // ])
            ])
          }
        }
      ],
      tableData: [],
      changeLoadingShow: false,
      changeLoadingShowSon: false,
      formItem: {
        id: 0,
        type_name: '',
        user: [],
        groups: [],
        is_approve: false,
        description: '',
        approve_email: '',
        cc_email: '',
        type_illustrate: ''
      },
      formItemSon: {
        id: 0,
        type_name: '',
        parent: null,
        user: [],
        groups: []
      },
      all_user_list: [],
      all_group_list: [],
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        type_name: [
          { required: true, validator: validTypeName, trigger: 'blur' }
        ]
      },
      ruleValidateSon: {
        type_name: [
          { required: true, validator: validTypeName, trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
    this.initOperatePerm()
    this.init()
  },
  methods: {
    // 初始化页面按钮权限（增删改查操作权限）
    initOperatePerm () {
      console.log(this.$store.state.user.permissions)
      let permissions = this.$store.state.user.permissions
      if (permissions.indexOf('operate_type') > -1) {
        this.isTypeOperate = true
        this.columns[this.columns.length - 1].width = 200
      } else {
        this.isTypeOperate = false
        this.columns[this.columns.length - 1].width = 1
      }
    },
    getTypeNameAll () {
      getTypeNameList().then(res => {
        this.typeNameList = res.data
      })
    },
    addParentType () {
      this.formItem = {
        id: 0,
        type_name: '',
        user: [],
        groups: [],
        is_approve: false,
        description: '',
        approve_email: '',
        cc_email: '',
        type_illustrate: ''
      }
      this.changeTitle = '添加分类'
      this.change = true
      this.getTypeNameAll()
    },
    onSonTypeDelete () {
      console.log('子组件触发onSonTypeDelete')
      this.getTypeNameAll()
    },
    typeNameValid (value) {
      if (this.typeNameList.indexOf(value) > -1) {
        return false
      } else {
        return true
      }
    },
    // 编辑表单中客服被移动触发
    changeUserSelect (newTarget) {
      this.formItem.user = newTarget
    },
    // 编辑表单中分组被移动触发
    changeGroupSelect (newTarget) {
      this.formItem.groups = newTarget
    },
    onResultChange (val) {
      this.changeSon = true
      this.formItemSon.type_name = val.type_name
      this.formItemSon.id = val.id
      this.formItemSon.parent = val.parent
      this.changeTitleSon = '修改子类' + val.type_name
      this.typeNameList = this.typeNameList.filter(item => item !== val.type_name)
    },
    // 初始化
    init () {
      this.getTableData()
      this.getAllUsersData()
      this.getAllGroupsData()
      this.getTypeNameAll()
    },
    // 获取表格数据
    getTableData (value = 1) {
      this.tableLoading = true
      this.page = value
      let params = {
        'size': this.size,
        'page': this.page
      }
      GetWorkSheetType(params).then(res => {
        this.tableData = res.data.results
        this.count = res.data.count
        this.tableLoading = false
      }).catch(res => {
        this.tableLoading = false
      })
    },
    changeClose () {
      this.formReset('formItem')
      this.getTypeNameAll()
    },
    changeCloseSon () {
      this.formResetSon('formItemSon')
      this.getTypeNameAll()
    },
    // 表单重置
    formReset (name) {
      this.formItem.id = 0
      this.$refs[name].resetFields()
    },
    // 表单重置
    formResetSon (name) {
      this.formItemSon.id = 0
      this.$refs[name].resetFields()
    },
    // 编辑表单提交
    changeSubmit () {
      // 检测游戏后面有没有;,没有则进行添加，方便客户端继续填写邮箱
      if (this.formItem.approve_email.slice(-1) !== ';' && this.formItem.approve_email) {
        this.formItem.approve_email += ';'
      }
      // 检测游戏后面有没有;,没有则进行添加，方便客户端继续填写邮箱
      if (this.formItem.cc_email.slice(-1) !== ';' && this.formItem.cc_email) {
        this.formItem.cc_email += ';'
      }
      if (this.formItem.user.length > 0 || this.formItem.groups.length > 0) {
        this.$refs['formItem'].validate((valid) => {
          if (valid) {
            this.changeLoadingShow = true
            ChangeWorkSheetType(this.formItem, this.formItem.id).then(res => {
              this.$Notice.success({ title: '操作成功！' })
              this.change = false
              this.formReset('formItem')
              this.getTableData()
              this.getTypeNameAll()
              this.changeLoadingShow = false
            }).catch(res => {
              this.changeLoadingShow = false
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          } else {
            this.$Notice.error({ title: '请检查输入框！' })
          }
        })
      } else {
        this.$Notice.error({ title: '请输入指派用户 或者 指派组！' })
      }
    },
    // 编辑表单提交子类
    changeSubmitSon () {
      this.$refs['formItemSon'].validate((valid) => {
        if (valid) {
          this.changeLoadingShowSon = true
          ChangeWorkSheetTypeSon(this.formItemSon, this.formItemSon.id).then(res => {
            this.$Notice.success({ title: '操作成功！' })
            this.changeSon = false
            this.formResetSon('formItemSon')
            this.getTableData()
            this.getTypeNameAll()
            this.changeLoadingShowSon = false
          }).catch(res => {
            this.changeLoadingShowSon = false
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        } else {
          this.$Notice.error({ title: '请检查输入框！' })
        }
      })
    },
    // 添加子类
    addSon (row) {
      console.log(row)
      this.changeSon = true
      this.changeTitleSon = '添加' + row.type_name + '的子类'
      this.formItemSon.parent = row.id
      this.getTypeNameAll()
    },

    // 编辑
    edit (row) {
      this.formItem.id = row.id
      this.formItem.type_name = row.type_name
      this.formItem.user = row.user
      this.formItem.groups = row.groups
      this.formItem.is_approve = row.is_approve
      this.formItem.description = row.description
      this.formItem.approve_email = row.approve_email
      this.formItem.cc_email = row.cc_email
      this.formItem.type_illustrate = row.type_illustrate
      this.formItem.file_name = row.file_name
      this.formItem.file_link = row.file_link
      this.changeTitle = '编辑分类'
      this.change = true
      this.typeNameList = this.typeNameList.filter(item => item !== row.type_name)
      this.handleChange(row.type_illustrate, row.type_illustrate)
      this.$refs.editor.setHtml(this.formItem.type_illustrate)
      console.log(this.typeNameList)
    },

    // 显示
    display (row) {
      row.is_display = true
      ChangeWorkSheetType(row, row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.init()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },
    // 隐藏
    hide (row) {
      row.is_display = false
      ChangeWorkSheetType(row, row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.init()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },
    // 删除
    delete (row) {
      DeleteWorkSheetType(row.id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.init()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },
    // 获取所有客服列表
    getAllUsersData () {
      this.all_user_list = []
      GetALLUsers({ groups__name: '客服人员' }).then(res => {
        let result = res.data
        for (let i in result) {
          this.all_user_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    // 获取所有分组列表
    getAllGroupsData () {
      this.all_group_list = []
      getAllGroup().then(res => {
        let result = res.data
        for (let i in result) {
          this.all_group_list.push({ key: result[i].id, label: result[i].name })
        }
      })
    },
    // 校验数字
    validNumberRule (rule, value, callback) {
      if (value === null) {
        callback(new Error())
      } else {
        callback()
      }
    },

    handleChange (html, text) {
      this.formItem.type_illustrate = html
    }
  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
